import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaRegistro: '1900-01-01',
    fechaEncuesta: moment(new Date()).format('YYYY-MM-DD'),
    encuestaUsuarioTipo: '',
    usuarioReferido: '',
    referencia: '',
    observaciones: '',
    rowVersion: null,

    items: [],
    calificacion: 0,
};

const mutations = {
    updateField,

    'INICIALIZAR' (state, encuestaUsuarioId) {
        state.id = encuestaUsuarioId || 0;
        state.fechaRegistro = '1900-01-01';
        state.fechaEncuesta = moment(new Date()).format('YYYY-MM-DD');
        state.encuestaUsuarioTipo = '';
        state.usuarioReferido = '';
        state.referencia = '';
        state.observaciones = '';
        state.rowVersion = null;

        state.items = [];
        state.calificacion = 0;
    },
    'SET_ENCUESTA' (state, encuestaUsuario) {
        state.fechaRegistro = moment(encuestaUsuario.fechaRegistro).format('YYYY-MM-DD');
        if (moment(encuestaUsuario.fechaEncuesta).format('YYYY-MM-DD') != '1900-01-01') {
            state.fechaEncuesta = moment(encuestaUsuario.fechaEncuesta).format('YYYY-MM-DD');
        }
        state.encuestaUsuarioTipo = encuestaUsuario.encuestaUsuarioTipo;
        state.usuarioReferido = encuestaUsuario.usuarioReferido;
        state.referencia = encuestaUsuario.referencia;
        state.observaciones = encuestaUsuario.observaciones.trim();
        state.rowVersion = encuestaUsuario.rowVersion;

        state.items = encuestaUsuario.items;
        calcularCalificacion(state);
    },
    'SET_CALIFICACION_ITEM' (state, params) {
        let item = state.items.find(i => i.id === params.itemId);
        if (item) {
            if (item.tipoConsulta == 1) {
                item.calificacion = params.calificacion;
            }
            if (item.tipoConsulta == 2) {
                item.aprobado = params.aprobado;
            }

            calcularCalificacion(state);
        }
    },
    'CALCULAR_CALIFICACION' (state) {
        calcularCalificacion(state);
    }
};

function calcularCalificacion(state) {
    let calificacionTotal = 0;
    let cantidadItems = 0;
    state.items.forEach(item => {
        if (item.tipoConsulta == 1) {
            calificacionTotal += item.calificacion;
            cantidadItems += 1;
        }
    });
    state.calificacion = cantidadItems > 0 ? helpers.methods.roundToTwo(calificacionTotal / cantidadItems) : 0;
}

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, encuestaUsuarioId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', encuestaUsuarioId);
            
            if (encuestaUsuarioId != 0) {
                apiAxios.get(`encuestas-usuarios/${encuestaUsuarioId}/abm`)
                    .then(res => {
                        commit('SET_ENCUESTA', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }   
        }, error => {
            reject(error);
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let encuestaUsuario = {
                fechaEncuesta: moment(state.fechaEncuesta).format('YYYY-MM-DD'),
                observaciones: state.observaciones.trim(),
                items: state.items.map(item => ({
                    id: item.id,
                    calificacion: item.calificacion,
                    aprobado: item.aprobado
                }))
            };

            let url = 'encuestas-usuarios';
            if (state.id != 0) {
                url += "/" + state.id;
                encuestaUsuario.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, encuestaUsuario)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setCalificacionItem( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('SET_CALIFICACION_ITEM', params);
            resolve();
        }, error => {
            reject(error);
        });
    },
    calcularCalificacion ( { commit } ) {
        commit('CALCULAR_CALIFICACION');
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}